import { CSSProperties } from 'react';
import { Product } from '../../../../apis/models/products/res/Product';
import ProductOptionItem from './ProductOptionItem';
import styled from 'styled-components';
import colors from '../../../../constants/colors.constants';
import Typo from '../../../../components/atom/Typo';
import useProductOptionsStore from '../../../../store/useProductOptionsStore';
import HighLighter from 'react-highlight-words';
import {
  sendTutorialTreatmentSelectedEvent,
  useTutorialStore,
} from '../../../../store/useTutorialStore';
import useAuthStore from '../../../../store/useAuthStore';
import {
  sendAddToCartEvent,
  sendRemoveFromCartEvent,
} from '../../../../utils/ga-utils';

export interface ProductItemProps {
  product: Product;
  searchKeyword?: string;
  tutorialProduct?: boolean;
  exhibitionId?: number;
}
function ProductItem(props: ProductItemProps) {
  const { partner } = useAuthStore();
  const {
    product,
    searchKeyword = '',
    tutorialProduct = false,
    exhibitionId,
  } = props;
  const { nextStep } = useTutorialStore();
  const {
    productOptions,
    productName,
    productIntroduction = '',
    categoryName,
    event,
  } = product;
  const {
    productOptions: selectedProductOptions,
    append,
    remove,
  } = useProductOptionsStore();

  const highlightStyle: CSSProperties = {
    fontWeight: 700,
    color: 'initial',
  };

  let tag = '';
  if (event) {
    tag = event.eventTitle;
  } else if (categoryName) {
    tag = categoryName;
  }

  return (
    <ProductWrapper>
      <ProductNameWrapper>
        <div className="flex flex-wrap gap-2 items-center">
          <Typo type="m-16">
            <HighLighter
              autoEscape
              highlightStyle={highlightStyle}
              textToHighlight={productName}
              searchWords={[searchKeyword]}
            >
              {productName}
            </HighLighter>
          </Typo>
          {tag && (
            <TagWrapper>
              <HighLighter
                autoEscape
                highlightStyle={highlightStyle}
                textToHighlight={tag}
                searchWords={[searchKeyword]}
              >
                {tag}
              </HighLighter>
            </TagWrapper>
          )}
        </div>

        {productIntroduction && (
          <div>
            <Typo type="r-12" color={colors.subTitle}>
              {productIntroduction}
            </Typo>
          </div>
        )}
      </ProductNameWrapper>
      <div>
        {productOptions.map((option, index) => {
          const isSelected =
            selectedProductOptions.filter(({ id }) => id === option.id).length >
            0;

          return (
            <ProductOptionItem
              key={option.id}
              customLabels={{
                zeroPriceLabel:
                  partner?.productViewConfig?.zeroPriceReplaceText,
                needConsultationLabel:
                  partner?.productViewConfig?.consultationReplaceText,
              }}
              tutorialProduct={index === 0 && tutorialProduct}
              isEvent={!!event}
              searchKeyword={searchKeyword}
              selected={isSelected}
              productOption={option}
              onClick={(productOption, isTutProductOption) => {
                if (isSelected) {
                  remove(productOption.id);
                  sendRemoveFromCartEvent([productOption]);
                } else {
                  append([
                    exhibitionId === undefined
                      ? productOption
                      : { ...productOption, exhibitionId },
                  ]);
                  sendAddToCartEvent([productOption]);
                  if (isTutProductOption) {
                    nextStep();
                  }
                }
              }}
            />
          );
        })}
      </div>
    </ProductWrapper>
  );
}

export default ProductItem;

const ProductWrapper = styled.div`
  border-radius: 16px;
  border: 1px solid ${colors.border1};
  overflow: hidden;
`;

const ProductNameWrapper = styled.div`
  padding: 16px;
  border-bottom: 1px solid ${colors.border1};
  background-color: ${colors.greyHover};
`;

const TagWrapper = styled.span`
  line-height: 16px;
  font-size: 11px;
  padding: 2px 6px;
  font-weight: 500;
  color: ${colors.primary3};
  border: 1px solid ${colors.primary3};
`;
